import { List } from '@monorepo/shared/componentsV2/List';
import { useSkipWidgetLink } from '@monorepo/shared/componentsV2/SkipWidgetLink';
import { lookFor } from '@monorepo/shared/utils/lookFor';
import React, { useMemo } from 'react';
import { DisplayQueryColumn } from '@monorepo/shared/componentsV2/QueryResultsTable/resultsMapper';
import { StyledListContainer, StyledNoResults } from './styles';
import {
  FilteredColumnListItem,
  StyledUnorderableListElement,
} from './UnorderableColumnListItem';

export function HiddenColumnList({
  hiddenColumns,
  isSaving,
  toggleColumnVisibility,
  filter,
}: {
  hiddenColumns: DisplayQueryColumn[];
  isSaving: boolean;
  toggleColumnVisibility: (column: DisplayQueryColumn) => void;
  filter: string;
}) {
  const { SkipLink, SkipLinkTarget } = useSkipWidgetLink();
  const filteredHiddenColumns = useMemo(
    () =>
      hiddenColumns.filter((column) =>
        lookFor(filter, column, ['columnLabel']),
      ),
    [filter, hiddenColumns],
  );
  return (
    <StyledListContainer>
      <SkipLink linkText="Skip past columns" />
      <List>
        {filteredHiddenColumns.length > 0 ? (
          filteredHiddenColumns.map((column) => (
            <FilteredColumnListItem
              column={column}
              disableShowHideButton={isSaving}
              toggleColumnVisibility={toggleColumnVisibility}
            />
          ))
        ) : (
          <StyledUnorderableListElement>
            <StyledNoResults>No results.</StyledNoResults>
          </StyledUnorderableListElement>
        )}
      </List>
      <SkipLinkTarget />
    </StyledListContainer>
  );
}
